<template>
    <form @submit.prevent="submit" class="vstack gap-4">
        <div>
            <label for="inputFullName" class="form-label">Full Name <sup class="text-danger">*</sup></label>
            <input type="text" id="inputFullName" v-model="contactForm.name" class="form-control" :class="errors.name ? 'is-invalid':''" placeholder="enter full name"  autofocus autocomplete="new-full-name">
            <div v-if="errors.name" class="invalid-feedback">
                {{ errors.name }}
            </div>
        </div>
        <div>
            <label for="inputEmail" class="form-label">Email<sup class="text-danger">*</sup></label>
            <input id="inputEmail" type="email" inputmode="email" v-model="contactForm.email" class="form-control" :class="errors.email ? 'is-invalid':''" placeholder="mail@example.com" value="" autofocus>
            <div v-if="errors.email" class="invalid-feedback">
                {{ errors.email }}
            </div>
        </div>
        <div>
            <label for="inputContact" class="form-label">Contact No.</label>
            <input type="tel" inputmode="numeric" class="form-control" :class="errors.contact_no ? 'is-invalid':''" v-model="contactForm.contact_no" @input="contactForm.contact_no = $filters.validateNumberInput(contactForm.contact_no)" id="inputContact" placeholder="e.g. 601233456789" autocomplete="new-contact_no">
            <div v-if="errors.contact_no" class="invalid-feedback">
                {{ errors.contact_no }}
            </div>
        </div>
        <div>
            <label for="enquiryMessage" class="form-label">Enquiries<sup class="text-danger">*</sup></label>
            <textarea class="form-control" :class="errors.message ? 'is-invalid':''" v-model="contactForm.message" id="enquiryMessage" placeholder="Leave an enquiry here" autocomplete="new-enquiry" rows="5">
            </textarea>
            <div v-if="errors.message" class="invalid-feedback">
                {{ errors.message }}
            </div>
        </div>
        <div class="text-center">
            <button class="btn btn-gradient-primary fs-15 px-5 py-3 rounded-4" type="submit" :disabled="contactForm.processing">
                Submit Enquiry <i v-if="contactForm.processing" class="fad fa-spinner-third fa-spin"></i>
            </button>
        </div>
    </form>

</template>
<script setup>
import { useReCaptcha } from 'vue-recaptcha-v3';
import { useForm } from '@inertiajs/vue3';

const props = defineProps({ errors : Object })
const { executeRecaptcha, recaptchaLoaded } = useReCaptcha()
const contactForm = useForm({
    name: null,
    email: null,
    contact_no: null,
    message: null,
})
async function submit() {
    await recaptchaLoaded()
    contactForm.g_recaptcha_response = await executeRecaptcha('contact')
    contactForm.post(route('front.enquiry.contact-us'));

    contactForm.reset();
}
</script>
